// extracted by mini-css-extract-plugin
export default {"cardWrapper":"ExperimentTypePage_cardWrapper__qEJsw","card":"ExperimentTypePage_card__QorDr","title":"ExperimentTypePage_title__EX3ZW"};